var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import "./common.css";
var DivFadeinCss = /** @class */ (function (_super) {
    __extends(DivFadeinCss, _super);
    function DivFadeinCss() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            entered: false,
        };
        _this.mounted = false;
        return _this;
    }
    DivFadeinCss.prototype.componentWillMount = function () {
        this.setState({
            entered: false,
        });
    };
    DivFadeinCss.prototype.componentDidMount = function () {
        var _this = this;
        this.mounted = true;
        setTimeout(function () {
            if (_this.mounted) {
                _this.setState({
                    entered: true,
                });
            }
        }, 10);
    };
    DivFadeinCss.prototype.componentWillUnmount = function () {
        this.mounted = false;
        //console.info('Will unmount')
    };
    DivFadeinCss.prototype.render = function () {
        var TagName = this.props.tagName || "div";
        return (React.createElement(TagName, { style: this.props.style, className: "fade-enter" +
                (this.state.entered ? " fade-enter-active" : "") +
                " " +
                (this.props.className || "") }, this.props.children));
    };
    return DivFadeinCss;
}(React.Component));
export { DivFadeinCss };
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Loader.prototype.render = function () {
        return (React.createElement(DivFadeinCss, { className: "p-3 text-center" },
            React.createElement("i", { className: "fa fa-spinner fa-spin" }),
            this.props.text ? React.createElement("span", null,
                " ",
                this.props.text,
                "...") : null));
    };
    return Loader;
}(React.Component));
export { Loader };
var Redirect = /** @class */ (function (_super) {
    __extends(Redirect, _super);
    function Redirect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Redirect.prototype.componentDidMount = function () {
        // window.history.replaceState({}, this.props.to, this.props.to); // this not emitting onhashchange
        // location.hash = this.props.to;
        location.replace(this.props.to);
    };
    Redirect.prototype.render = function () {
        return React.createElement(Loader, { text: "Redirecting to " + this.props.to });
    };
    return Redirect;
}(React.Component));
export { Redirect };
/*
export class Tabs extends React.Component<
    {
        tabs: JSX.Element[];
    },
    {
        activeTabId: number;
        prevActiveTabId: number;
    }
> {
    state = {
        activeTabId: 0,
        prevActiveTabId: -1
    };
    render() {
        return (
            <div className="mb-3">
                {this.props.tabs.length > 1 ?
                <div className="mb-3">
                    {this.props.tabs.map((tab, id) => (
                        <button
                                className={`btn mx-2 ${
                                    id === this.state.activeTabId
                                        ? "btn-primary"
                                        : "btn-light"
                                }`}
                          
                                onClick={e => {
                                    e.preventDefault();
                                    this.setState(
                                        {
                                            prevActiveTabId: this.state
                                                .activeTabId,
                                            activeTabId: id
                                        },
                                        () => {
                                            setTimeout(() => {
                                                this.setState({
                                                    prevActiveTabId: -1
                                                });
                                            }, 300);
                                        }
                                    );
                                }}
                            >
                                {tab}
                        </button>
                    ))}
                </div> : null}
                <div className="tab-content">
                    {React.Children.map(this.props.children, (child, i) => {
                        return (
                            <div
                                key={i}
                                className={
                                    `tab-pane fade ` +
                                    (this.state.prevActiveTabId > -1
                                        ? i === this.state.prevActiveTabId
                                            ? "active"
                                            : ""
                                        : i === this.state.activeTabId
                                            ? "active show"
                                            : "")
                                }
                            >
                                {child}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

*/
var ErrorInfo = /** @class */ (function (_super) {
    __extends(ErrorInfo, _super);
    function ErrorInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInfo.prototype.render = function () {
        var e = this.props.error;
        console.warn(e);
        return (React.createElement("div", { className: "text-center p-3 text-danger" },
            e instanceof Error ? (React.createElement("div", null,
                React.createElement("div", null,
                    e.name,
                    ": ",
                    e.message),
                React.createElement("div", null, e.stack))) : (React.createElement("span", null, e.toString())),
            React.createElement("div", null, this.props.children)));
    };
    return ErrorInfo;
}(React.Component));
export { ErrorInfo };
//# sourceMappingURL=data:application/json;base64,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